import { FC } from 'react';
import { Text, TextProps } from '@chakra-ui/react';

/**
 * A description to be used inside an OBCardRow.Body
 */
const BodyDescription: FC<TextProps> = ({ children, ...props }) => (
  <Text margin="space-0" size="xs" {...props}>
    {children}
  </Text>
);

export default BodyDescription;
